import BaseProxy from "../../base-proxy";

/**
 * @class AllTypePaymentPostProxy
 * @description Class used for communicating with payment all type API.
 * @author Aldrev Ven Dayrit
 * @version 1.0
 * @since June 26, 2019
 */
export default class AllTypePaymentPostProxy {
  /**
   * @async
   * @function execute
   * @param input Generic input parameter instance
   * @param data - Generic data parameter instance.
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} input.card_id - Credit Card Id.
   * @param {Array} input.companySubscriptionIds - Company subscription ids.
   * @param {Array} input.oneOffCodes - One Off xero codes
   * @param {String} input.companyId
   */
  async postPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let subscriptionIds = input.companySubscriptionIds
      .map((subscriptionId) => `companySubscriptionIds=${subscriptionId}`)
      .join("&");
    let oneOffCodes = input.oneOffCodes.map((codes) => `oneOffCodes=${codes}`).join("&");
    let endpointUrl = `${backendUrl}/payment/all-types?companyId=${input.companyId}&${subscriptionIds}&${oneOffCodes}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async postManualPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let subscriptionIds = input.companySubscriptionIds
      .map((subscriptionId) => `companySubscriptionIds=${subscriptionId}`)
      .join("&");
    let oneOffCodes = input.oneOffCodes.map((codes) => `oneOffCodes=${codes}`).join("&");
    let endpointUrl = `${backendUrl}/payment/manual-payment-request?companyId=${input.companyId}&${subscriptionIds}&${oneOffCodes}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async postUpgradeManualPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/payment/manual-payment-upgrade-corpsec?companyId=${input.companyId}`;
    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async postUpgradePayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/payment/upgrade-corpsec?companyId=${input.companyId}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  /**
   * @async
   * @function upgradeCorpSecSubscriptionPayment
   * @param input Generic input parameter instance
   * @param data - Generic data parameter instance.
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} input.card_id - Credit Card Id.
   * @param {Array} input.payment_token - Payment token.
   * @param {Array} input.company_id - Company Id.
   * @param {Array} input.total_number_of_shareholder - Total number of shareholder plus the new shareholder.
   */

  async upgradeCorpSecSubscriptionPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/billing-payment/corp-sec-subscription/upgrade/card`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async upgradeCorpSecSubscriptionManualPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/billing-payment/corp-sec-subscription/upgrade/bank`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async unpaidBillPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/billing-payment/unpaid/card`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }

  async unpaidBillManualPayment(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/v2/billing-payment/unpaid/bank`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
